import { AloftPrice } from '@aloft/toolkit-shared';

import { AdjPairedLocalAdjustments } from './types.ts';

export const getTotalAdjustedValuePaired = (
  basePrice: AloftPrice | null,
  adjustments: AdjPairedLocalAdjustments,
) => {
  const netAdjustment = AloftPrice.addWithNulls(...Object.values(adjustments));
  return AloftPrice.addWithNulls(basePrice, netAdjustment) ?? undefined;
};
